import { useMemo } from "react";

import { resolveAppPathwayBundles } from "@/routes/appPathwayBundles";

import { useAppAuth } from "./useAppAuth";
import { useUserRole } from "./useUserRole";

export function useAppPathwayBundles() {
  const { authenticated } = useAppAuth();
  const { isSfsAdmin, isConsultantManager, isAuditor, isAuditorInClientOrg, isClient } =
    useUserRole();

  return useMemo(
    () =>
      resolveAppPathwayBundles({
        authenticated,
        isSfsAdmin,
        isConsultantManager,
        isAuditor,
        isAuditorInClientOrg,
        isClient,
      }),
    [
      authenticated,
      isSfsAdmin,
      isConsultantManager,
      isAuditor,
      isAuditorInClientOrg,
      isClient,
    ],
  );
}
